<template>
  <div class="doctor-new width-responsiveness--centralized">
    <modal
      ref="transferModal"
      template="loading"
      ref-name="transferModal"
      title="Aguarde"
    >
      <p>Salvando Médico...</p>
    </modal>

    <div class="doctor-new__container">
      <subheader
        :title="title"
        :centralized="true"
        :back-button-visible="true"
      />

      <div
        v-if="loading"
        class="doctor-new__loading"
      >
        <Spinner />
      </div>

      <div
        v-else
        class="doctor-new__container input-forms"
      >
        <div class="doctor-new__form">
          <card-form :collapsed="true">
            <div
              slot="expanded"
              class="form-container"
            >
              <md-layout
                :md-gutter="24"
                md-flex="100"
              >
                <!-- form title -->
                <md-layout
                  md-flex="100"
                  md-flex-medium="100"
                >
                  <h2
                    id="doctorFormTitle"
                    class="orders-new__doctor__title title-main"
                  >
                    Dados do Médico
                  </h2>
                </md-layout>

                <!-- name field -->
                <md-layout
                  md-flex="100"
                  md-flex-medium="100"
                >
                  <md-input-container
                    id="doctorName"
                    :class="{'md-input-invalid': errors.has('name')}"
                  >
                    <label>Nome do Médico *</label>
                    <md-input
                      id="txtNewdoctorName"
                      v-model="doctor.name"
                      v-validate="'required'"
                      data-vv-validate-on="none"
                      name="name"
                      maxlength="60"
                      type="text"
                      title
                      placeholder="Nome do médico *"
                    />
                    <span class="md-error">Obrigatório</span>
                  </md-input-container>
                </md-layout>

                <md-layout
                  md-flex="100"
                  md-flex-medium="100"
                  style="height: 15px"
                />

                <!-- crm field -->
                <md-layout
                  md-flex="50"
                  md-flex-medium="50"
                >
                  <md-input-container id="doctorCRM">
                    <label>CRM*</label>
                    <md-input
                      id="txtCRM"
                      v-model="doctor.crm"
                      v-validate="'required'"
                      v-mask="'##########'"
                      data-vv-validate-on="none"
                      name="txtCRM"
                      maxlength="10"
                      type="text"
                      title=""
                      placeholder="CRM*"
                    />
                  </md-input-container>
                </md-layout>

                <!-- uf field -->
                <md-layout
                  md-flex="50"
                  md-flex-medium="50"
                >
                  <md-input-container
                    id="doctorUF"
                    name="UF"
                    :class="{
                      'md-input-placeholder md-advanced-select': true,
                      'md-has-value': doctor.uf,
                      'md-input-invalid': errors.has('feature'),
                    }"
                  >
                    <label for="txtUF">UF*</label>
                    <AdvancedSelect
                      id="txtUF"
                      v-model="doctor.uf"
                      v-validate="'required'"
                      :options="optionsUF"
                      placeholder=""
                      name="txtUF"
                      data-vv-validate-on="none"
                      title=""
                    />
                  </md-input-container>
                </md-layout>
              </md-layout>
            </div>
          </card-form>
        </div>

        <div class="doctor-new__footer">
          <button
            class="btn-bordered"
            @click="$router.push('/doctor')"
          >
            Cancelar
          </button>
          <button 
            id="newProfileBtn"
            class="btn-primary"
            @click="validateBeforeSubmit()"
          >
            <img
              src="/static/images/icon-check-white.svg"
              alt="icone-salvar"
            >
            {{ isEdit ? 'Salvar alterações' : 'Salvar' }}
          </button>
        </div>
      </div>
    </div>
    <page-scroll-top />
  </div>
</template>

<script>
import CardForm from '@/components/common/CardForm'
import doctorService from '@/api/doctor'
import Spinner from '@/components/common/Spinner'
import notify from '@/api/notification'
import SubHeader from '@/components/common/SubHeader'
import PageScrollTop from '@/components/common/PageScrollTop'
import AdvancedSelect from '@/components/common/AdvancedSelect'
import strings from '@/strings'
import { mask } from 'vue-the-mask'

export default {
  name: 'DoctorNew',
  components: {
    subheader: SubHeader,
    'page-scroll-top': PageScrollTop,
    'card-form': CardForm,
    AdvancedSelect,
    Spinner
  },
  directives: {
    mask: mask
  },
  data: () => ({
    optionsUF: strings.brazilStates,
    doctor: {
      name: '',
      crm: '',
      uf: ''
    },
    isEdit: false,
    loading: false,
    searchInput: ''
  }),
  computed: {
    title () {
      if (this.isEdit) return 'Editar médico'
      return 'Novo médico'
    }
  },
  mounted () {
    const id = this.$route.params.id
    // if route has id load profile to edit
    if (id) {
      this.isEdit = true
      this.loading = true

      doctorService
        .getDoctorById(id)
        .then((res) => {
          this.doctor.name = res.data.name
          this.doctor.crm = res.data.crm
          this.doctor.uf = {label: res.data.uf, value: res.data.uf}
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          notify({
            title: 'AVISO:',
            message: 'Erro ao carregar médico para edição.'
          })
        })
    }
  },
  beforeDestroy () {
    this.loading = false
    this.isEdit = false
  },
  methods: {
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.handleCreate()
          return
        }
      })
    },
    handleCreate () {
      const doctor = {
        'crm': this.doctor.crm,
        'uf': this.doctor.uf.label,
        'name': this.doctor.name
      }
      let msgText = 'criado'
      const endpoint = this.isEdit ? 'editDoctor' : 'createDoctor'
      this.openModal()

      if (this.isEdit) {
        doctor.id_doctor = this.$route.params.id
        msgText = 'atualizado'
      }
      doctorService[endpoint](doctor)
        .then((response) => {
          if (response) {
            notify({
              message: 'Médico ' + msgText + ' com sucesso!'
            })
            this.closeModal()
            this.$router.push('/doctor')
          }
        })
        .catch(error => {
          notify({
            title: 'AVISO:',
            message: error.response.data.message
          })
          this.closeModal()
        })
    },
    closeModal () {
      this.$refs.transferModal.close()
    },
    openModal () {
      this.$refs.transferModal.open()
    },
    focusNextField (id) {
      document.getElementById(id).focus()
    }
  }
}
</script>

<style lang="scss">
@import "../../../static/stylesheets/mixins";

.doctor-new {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 58px);
  margin-top: 142px;

  .md-advanced-select {
    label {
      color: #7A7A7A !important;
    }
  }
  &__doctor {
    h3 {
      font-size: 22px;
      font-weight: 400;
      letter-spacing: -.3px;
      text-align: left;
      color: #7a7a7a;
      line-height: 30px;      
    }
  }
  &__modal {
    text-align: center;

    &-loading {
      min-height: 90px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    h3 {
      font-family: Roboto;
      font-weight: 400;
      text-align: center;
      font-size: 20px;
      margin-top: 20px;
      letter-spacing: 0;
    }
  }
  &__modal-text {
    border-top: 1px solid #b8b7bf;
    padding-top: 20px;
    max-width: 270px;
    margin: 20px auto 0;
  }

  &__search-exams {
    margin-bottom: 30px;
  }

  &__text {
    margin-bottom: 10px;
    font-weight: normal;
    font-size: 22px;
    color: #7A7A7A;
  }

  &__loading {
    min-height: 65vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__container {
    width: 100%;
  }

  &__form {
    margin-bottom: 35px;
    p {
      font-size: 15px;
      letter-spacing: -0.3px;
      color: #303030;
      margin-bottom: 15px;
    }
    .card-form {
      &__container {
        border-radius: 6px;
        padding-bottom: 27px;
      }
    }
    .md-input-container {
      margin: 0 !important;
    }
  }

  &__footer {
    margin-top: 30px;
    margin-bottom: 50px;
    display: flex;
    justify-content: space-between;

    .btn-bordered {
      padding: 5px 28px;
      text-transform: uppercase;
      background: none;
      border: 2px solid #7f1a54;
      border-radius: 3px;
      font-size: 12px;
      font-weight: 500;
      letter-spacing: .8px;
      color: #7f1a54;
      height: 38px;
    }
    .btn-primary {
      text-transform: uppercase;
      padding: 5px 37px;
      border-radius: 3px;
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 0.8px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        margin-right: 5px;
      }
    }
  }
}
</style>
